module.exports = __webpack_public_path__ + "static/media/comming_soon_blur.2b5258f9.jpg";